var map = {
	"./DuckAltLogo.png": 9366,
	"./Explosion.png": 454,
	"./HeroImage.jpg": 7776,
	"./HeroImageSmall.jpg": 8367,
	"./IMG_0598.WEBP": 931,
	"./LeaderBoard.png": 5670,
	"./Logo.png": 5926,
	"./RaceDucks.mov": 1266,
	"./RaceDucks.mp4": 741,
	"./RaceDucksQR.PNG": 7092,
	"./Tree.png": 2059,
	"./cars/BlueCar.png": 8845,
	"./cars/BlueCar1.png": 4496,
	"./cars/DuckGame.png": 7506,
	"./cars/DuckGame1.png": 9585,
	"./cars/GreenCar.png": 4362,
	"./cars/GreenCar1.png": 633,
	"./cars/OrangeCar.png": 5599,
	"./cars/OrangeCar1.png": 4390,
	"./cars/RedCar.png": 5558,
	"./cars/RedCar1.png": 1709,
	"./crashDuck.png": 9953,
	"./start/Start.png": 890,
	"./start/Start1.png": 4937,
	"./start/Start2.png": 930,
	"./start/Start3.png": 4587,
	"./start/Start4.png": 2596,
	"./start/Start5.png": 3725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;